var exports = {
  "kL": "xfb577c5e--80a9fd--container",
  "Qs": "xfb577c5e--80a9fd--content",
  "qr": "xfb577c5e--80a9fd--footer",
};

module.exports = exports;
